module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-active@2x-1630157b.png";